// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/post-feedback-request-schema',
  type: 'object',
  required: ['companyId', 'eventRating', 'reparticipationRating', 'youthVisitorsCount', 'eventIdentifier'],
  properties: {
    companyId: {
      type: 'integer',
    },
    eventRating: {
      type: 'integer',
    },
    reparticipationRating: {
      type: 'integer',
    },
    youthVisitorsCount: {
      type: 'integer',
    },
    adultVisitorsCount: {
      type: 'integer',
      nullable: true,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
